import { useEffect } from 'react'

const useScrollToTopOnMount = () => {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])
}

export default useScrollToTopOnMount
